// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3pXdB","rightAdornment":"Header_rightAdornment__1yWiP"};